export default __webpack_public_path__ + "static/portfolio-cover-3-6813f9509088f1f08568ba6451a2a07b.jpg";